/**
 * «Недавние» на главном экране (§2.1) — последние 5 открытых номеров.
 *
 * `localStorage`, не IndexedDB/outbox: это не данные API и не бизнес-
 * состояние, а мелкое читательское удобство — список номеров, который
 * скаут уже видел. Правило «данные API не в Cache Storage» (`offline/
 * outbox.ts`) сюда не относится: здесь никогда не лежит ничего, что пришло
 * с сервера, — только id и номер байка, на который сам скаут только что
 * смотрел.
 */

const KEY = 'aida.scout.recent'
const MAX = 5

export type RecentBike = { id: string; number: string }

function isRecentBike(v: unknown): v is RecentBike {
  return (
    typeof v === 'object' &&
    v !== null &&
    typeof (v as RecentBike).id === 'string' &&
    typeof (v as RecentBike).number === 'string'
  )
}

/** Никогда не бросает: битое хранилище — пустой список, а не сломанный экран. */
export function readRecentBikes(): RecentBike[] {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return []
    const parsed: unknown = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter(isRecentBike) : []
  } catch {
    return []
  }
}

/** Открытый байк — наверх списка. Повтор не дублируется, поднимается. */
export function pushRecentBike(bike: RecentBike): void {
  try {
    const rest = readRecentBikes().filter((b) => b.id !== bike.id)
    localStorage.setItem(KEY, JSON.stringify([bike, ...rest].slice(0, MAX)))
  } catch {
    /* приватный режим/квота — не критично, просто не запомним */
  }
}
